import React from 'react';
import styles from './Icon.module.scss';

const Icon = ({ isFavorite, className, ...props }) => {
    return (
        <i
            className={`icon-star ${className} ${styles.starIcon} 
                        ${isFavorite ? styles.active : ''}`}
            {...props}
        />
    );
};

export default Icon;
